import { Fragment } from 'react'
import type { ReactNode } from 'react'
import { parseInline } from '../../docs/markdown'
import type { InlineNode } from '../../docs/markdown'
import styles from './Docs.module.scss'

function renderNodes(nodes: InlineNode[]): ReactNode[] {
  return nodes.map((node, index) => {
    switch (node.type) {
      case 'code':
        return (
          <code key={index} className={styles.inlineCode}>
            {node.text}
          </code>
        )
      case 'strong':
        return <strong key={index}>{renderNodes(node.children)}</strong>
      case 'em':
        return <em key={index}>{renderNodes(node.children)}</em>
      case 'link': {
        const external = /^https?:/i.test(node.href)
        return (
          <a
            key={index}
            href={node.href}
            {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
          >
            {renderNodes(node.children)}
          </a>
        )
      }
      default:
        return <Fragment key={index}>{node.text}</Fragment>
    }
  })
}

/**
 * Renders one line of documentation text with the inline Markdown the
 * backend's OpenAPI document uses: `code`, **bold**, *italic* and links
 * (see `docs/markdown.ts`).
 */
export function DocInline({ text }: { text: string }): ReactNode {
  return <>{renderNodes(parseInline(text))}</>
}
